export default __webpack_public_path__ + "static/media/screen.1f5df03e.svg";